<template>
  <div class="app-container crm-follow-list">
    <el-form :model="queryParams" ref="queryForm" class="multipleSelectScroll" v-show="showSearch" label-width="100px">
      <el-row :gutter="10" class="mb8">
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :auth-check="false" :user-label="'员工姓名'" :user-id-field="'userIdList'"></dept-user-select>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="年份" prop="targetTime">
            <el-date-picker
              v-model="queryParams.targetTime"
              value-format="yyyy"
              type="year"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :md="12" :lg="6" :offset="18" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8 pb5">
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>
    <el-row class="mb8 pt5">
      <el-col :xs="24" :md="12" :lg="18" align="left">
        <div style="font-size: 14px;" class="mb8">
          <el-row class="mb8 pt5">
            <el-col :xs="24" :md="12" :lg="8" align="left">
              签约总目标（元）：{{ amountFormat(otherData.totalTargetSignAmount / 10000) }}万
            </el-col>
            <el-col :xs="24" :md="12" :lg="8" align="left">
              签约总金额（元）：{{ amountFormat(otherData.totalSignAmount / 10000) }}万
            </el-col>
            <el-col :xs="24" :md="12" :lg="8" align="left">
              签约达成率：{{ otherData.signAchieveRete || 0 }}%
            </el-col>
          </el-row>
        </div>
        <div style="font-size: 14px;" class="mb8">
          <el-row class="mb8 pt5">
            <el-col :xs="24" :md="12" :lg="8" align="left">
              回款总目标（元）：{{ amountFormat(otherData.totalTargetFundAmount / 10000) }}万
            </el-col>
            <el-col :xs="24" :md="12" :lg="8" align="left">
              回款总金额（元）：{{ amountFormat(otherData.totalFundAmount / 10000) }}万
            </el-col>
            <el-col :xs="24" :md="12" :lg="8" align="left">
              回款达成率：{{ otherData.fundAchieveRete || 0 }}%
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :xs="24" :md="12" :lg="6" align="right">
        <el-button @click="$router.push('/crm/monthly-appraisal')" v-hasPermi="['crm:appraisal:view']">月度绩效考核</el-button>
        <el-button type="primary" @click="handleTarget" v-hasPermi="['crm:performanceTarget:manage']">目标管理</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="员工姓名" width="100" align="center" prop="nickName" />
      <el-table-column label="部门" min-width="120" align="center" prop="deptName"></el-table-column>
      <el-table-column label="年份" min-width="100" align="center" prop="targetTime"></el-table-column>
      <el-table-column label="签约目标(元)" min-width="100" align="center" prop="signTargetAmount">
        <template slot-scope="scope">
            <span class="content">{{scope.row.signTargetAmount ? amountFormat(scope.row.signTargetAmount / 10000): 0}}万</span>
        </template>
      </el-table-column>
      <el-table-column label="实际签约(元)" align="center" prop="actualSignAmount">
        <template slot-scope="scope">
            <span class="content">{{scope.row.actualSignAmount ? amountFormat(scope.row.actualSignAmount / 10000) : 0}}万</span>
        </template>
      </el-table-column>
      <el-table-column label="签约达成率" align="center" prop="fundAchieveRete">
        <template slot-scope="scope">
          <span class="content">{{scope.row.signAchieveRete || 0}}%</span>
        </template>
      </el-table-column>
      <el-table-column label="回款目标(元)" align="center" prop="fundTargetAmount">
        <template slot-scope="scope">
          <span class="content">{{scope.row.fundTargetAmount ? amountFormat(scope.row.fundTargetAmount / 10000) : 0}}万</span>
        </template>
      </el-table-column>
      <el-table-column label="实际回款(元)" align="center" prop="actualFundAmount">
        <template slot-scope="scope">
          <span class="content">{{scope.row.actualFundAmount ? amountFormat((scope.row.actualFundAmount) / 10000) : 0}}万</span>
        </template>
      </el-table-column>
      <el-table-column label="回款达成率" align="center" prop="fundAchieveRete">
        <template slot-scope="scope">
          <span class="content">{{scope.row.fundAchieveRete || 0}}%</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { listByPage } from "@/api/crm/kpi";
import { businessTargetTypeToPath } from "@/utils/crm";
import { amountFormat } from "@/utils/index";
import deptUserSelect from "@/views/crm/components/deptUserSelect";

export default {
  name: "FollowManage",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: false,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      otherData: {},
      deptOptions: [],
      userOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        queryType: 1,
        deptIdList: [],
        userIdList: [],
        targetTime: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUser: state => state.user,
      dept: state => state.user.dept,
      userDataScope: state => state.user.userDataScope
    })
  },
  components: {
    deptUserSelect
  },
  mounted() {
    this.queryParams.userIdList = [this.currentUser.userId]
    this.handleQuery()
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0];
        params.endDate = params.createTime[1];
      }
      params.createTime = undefined;
      listByPage(params)
        .then(response => {
          this.dataList = response.rows;
          this.otherData = response.otherData || {};
          this.total = response.total;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 跳转目标管理
    handleTarget() {
      this.$router.push("/crm/kpi/target");
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open(
        "/crm/" +
          businessTargetTypeToPath(row.targetType) +
          "/detail/" +
          row.targetId,
        "_blank"
      );
    }
  }
};
</script>

<style lang='scss'>
.crm-follow-list {
  .content {
    word-break: break-all;
    line-height: 1.5em;
  }
}
</style>
